// Do not use = [] or = {} on hook/component params or useMemo fallbacks
// that feed useEffect/useMemo deps. Import a constant from this file.

/** @see hooks.js useAffordableQualifications — ENG-28187 / HUD reopen completed-tab */
export const EMPTY_ARRAY = Object.freeze([]);
export const EMPTY_OBJECT = Object.freeze({});

export const EMPTY_RESIDENT_AFFORDABLE_QUALIFICATIONS = EMPTY_ARRAY;
export const EMPTY_HOUSEHOLD_AFFORDABLE_DETAILS = EMPTY_OBJECT;
export const EMPTY_QUALIFICATION_OPTIONS = EMPTY_ARRAY;
export const EMPTY_QUALIFICATION_DATA = EMPTY_OBJECT;
export const EMPTY_AFFORDABLE_SETUP = EMPTY_OBJECT;
export const EMPTY_AFFORDABLE_QUALIFICATIONS_LIST = EMPTY_ARRAY;
export const EMPTY_PREVIOUS_ASSISTANCE_DETAILS = EMPTY_OBJECT;

/**
 * ENG-31723: the unrestricted default for a program's floor-plan spans and gap
 * regions. These feed memo/effect dependency lists on both the Start
 * Certification modal and the Certification Details drawer, from the tab
 * containers all the way down, so every hop in that chain must default to this
 * constant rather than a fresh `[]`.
 */
export const EMPTY_FLOOR_PLAN_SPANS = EMPTY_ARRAY;
